import { useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DataTable } from "./DataTable";
import { useNavModel } from "@/model/navModel";
import { useSummaryModel } from "./summaryModel";
import { globalPrompt } from "@/components/YhMessage";
import { DetailActionTypeEnum, useDetailModel } from "../contractDetail/detailModel";
import { contractManageService } from "@/views/contract/manage/ContractManageService";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const DataBox = () => {

    const { addNav } = useNavModel();
    const {
        dataSource, loadData,
        selectedRowKeys,
        setSelectedData, selectedData,
        setDetailPartner, setDetailCode,
        setAdjustMonthDrawerVisible
    } = useSummaryModel();

    const { setCustomerCode, setTitle, setActionType } = useDetailModel();

    useEffect(() => {
        let filters = dataSource?.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] || el.partnerCode === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData);

        //详情搜索key
        setDetailPartner(selectedData?.partnerCode ?? "");
        setDetailCode(selectedData?.code ?? "");

    }, [selectedRowKeys]);

    const onDetail = () => {
        if (selectedRowKeys && selectedRowKeys.length === 1) {
            if (selectedData) {
                setCustomerCode(selectedData.partnerCode);
                setTitle(selectedData.partnerName);
            }
            setActionType(DetailActionTypeEnum.STATEMENT)
            addNav("16-1-1");
        } else {
            message.error("请选择记录!");
        }
    }

    const onTerminate = () => {
        if (selectedRowKeys && selectedRowKeys.length === 1) {
            selectedData && globalPrompt("modal", {
                title: "警告", type: "warning", text: "是否确认终止合约", onOk: async () => {
                    await contractManageService.terminate(selectedData.code);
                    message.success("操作成功!");
                    loadData().then();
                },
                cancelShow: true,
            })
        } else {
            message.error("请选择记录!");
        }
    }

    const action = (
        <>
            <div>
                {<Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => setAdjustMonthDrawerVisible(true)}
                >新增合约</Button>}
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onDetail}
                >查看</Button>
                <YhAuth resCode={ResourceAuthEnum.DATA_CONTRACT_TERMINATE}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={onTerminate}
                    >合约终止</Button>
                </YhAuth>
            </div>
        </>
    );

    return (
        <YhBox title={action}>
            <DataTable />
        </YhBox>
    )
}
